// extracted by mini-css-extract-plugin
export var bars = "styles-module--bars--eebb7";
export var chart = "styles-module--chart--5350a";